export { default } from './EditProtocolTemplate';
